import {Suspense} from 'react';
import {BrowserRouter, Route} from 'react-router-dom'
import {homepage} from '../../package.json';
import {ErrorBoundary} from 'react-error-boundary';
import ErrorFallback from '@super-template/core/src/ErrorFallback';
import IntlMessagesProvider from '@super-template/core/src/IntlMessagesProvider';
import Theme from '@super-template/theme';
import {QueryParamProvider} from 'use-query-params';
import {LinearProgress} from '@material-ui/core';
import {Layout} from '@super-template/core/src/LayoutFallback';
import {RuntimeConfigProvider} from '@super-template/core/src/runtimeConfig';
import runtimeConfigDefaults from 'runtimeConfigDefaults';
import Page from "./layouts/Page";
import {SnackbarReduxWrapper} from '@super-template/core/src/snackbar';
import ReactKeycloakProvider from "@super-template/react-keycloak-provider";
import Routes from './Routes';

export default function App() {
  return (
    <Suspense fallback={null}>
      <RuntimeConfigProvider defaults={runtimeConfigDefaults}>
        <Theme>
          <Suspense fallback={<LinearProgress/>}>
            <IntlMessagesProvider>
              <ErrorBoundary FallbackComponent={ErrorFallback}>
                <Layout FallbackComponent={Page}>
                  <ReactKeycloakProvider>
                    <BrowserRouter basename={homepage}>
                      <QueryParamProvider ReactRouterRoute={Route}>
                        <Routes/>
                        <SnackbarReduxWrapper/>
                      </QueryParamProvider>
                    </BrowserRouter>
                  </ReactKeycloakProvider>
                </Layout>
              </ErrorBoundary>
            </IntlMessagesProvider>
          </Suspense>
        </Theme>
      </RuntimeConfigProvider>
    </Suspense>
  );
}
